/**
 * ColorSwatch.jsx — Themed wrapper around <input type="color"> (issue #267).
 *
 * Replaces the bare browser-default color picker with a styled swatch
 * button + hex label. Clicking the pill opens the native color picker.
 *
 * CSP-safe: Solid compiles onClick to addEventListener — no inline handlers.
 *
 * Props:
 *   value   — current hex string, e.g. "#FF7433"
 *   onInput — native input event handler (e.currentTarget.value is the hex)
 */

export default function ColorSwatch(props) {
  let inputRef;

  function trigger() { inputRef?.click(); }

  return (
    <span class="v2-color-swatch">
      <button
        type="button"
        class="v2-color-swatch__btn"
        style={{ '--swatch': props.value }}
        onClick={trigger}
        aria-label={`Pick embed colour — current: ${props.value || 'none'}`}
        title="Pick embed colour"
      />
      <input
        ref={inputRef}
        type="color"
        class="v2-color-swatch__input"
        value={props.value}
        onInput={props.onInput}
        tabIndex="-1"
        aria-hidden="true"
      />
      <span class="v2-color-swatch__hex">{props.value}</span>
    </span>
  );
}
